module.exports = __webpack_public_path__ + "static/img/protection.be0f6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/protection.png
// module id = sDiv
// module chunks = 0